import { Component, Input } from '@angular/core';
import { LoadingController, NavController, NavParams, Platform } from 'ionic-angular';
import { Subject } from 'rxjs';
import { EventProvider } from '../../../../providers/event/event';
import { ResultProvider, StatisticsResults } from '../../../../providers/result/result';
import { Chart } from 'chart.js';
import { SessionProvider } from '../../../../providers/session/session';
import { TranslateService } from '@ngx-translate/core';
import { ScreenRotatableService } from '../../../../providers/screen-rotatable/screen-rotatable.service';
import { ActivityService } from '../../../../providers/activities.service';
import { AdsProvider } from '../../../../providers/ads/ads';
import { ThemeMode } from '../../../../providers/dark-mode/dark-mode';

@Component({
  selector: 'page-activity-statistics',
  templateUrl: 'activity-statistics.html'
})
export class ActivityStatisticsPage {
  @Input('instance') parentInstance;


  tab: string = "activity";
  update: Subject<StatisticsResults> = null;
  activeEndurance;
  endurances: any = [];

  treesCounter = {
    kilometer: "000",
    units: "000",
    trees: "000"
  };

  events = [];
  trainings = [];
  isHeaderEnabled = true;
  years = [0];
  reload: boolean = true;
  noData = false;
  @Input() defaultOrientation: boolean;

  orientationSub = null;
  noActivitiesMessage:string ="";
  themeMode
  constructor(
    public navCtrl: NavController,
    private navParams: NavParams,
    private eventService: EventProvider,
    private sessionService: SessionProvider,
    private resultService: ResultProvider,
    private loadingCtrl: LoadingController,
    private screen: ScreenRotatableService,
    private ads: AdsProvider,
    private platform: Platform,
    private activityService: ActivityService,
    private translate: TranslateService) {
    this.getEndurances().then(() => {
      this.screen.onChange.subscribe(() => {
        this.isHeaderEnabled = this.screen.getOrientationType().includes('landscape') ? false : true;
      });
      this.getTrainingsData();
      this.filterData();
      for (let i = 0; i < this.years.length; i++) {
        this.configureChart(i);
      }
    });
    this.noActivitiesMessage = this.translate.instant('NO_ACTIVITIES');
  }

  ngOnInit() {
    this.themeMode =  JSON.parse(localStorage.getItem('darkMode') || `"${ThemeMode.LightMode}"`) as ThemeMode;
    this.unlockOrientations();
    this.orientationSub = this.screen.onChange.subscribe(() => {
      this.defaultOrientation = this.screen.getOrientationType().includes('landscape') ? false : true;
      if (this.defaultOrientation) {
        let tab = document.getElementsByClassName('show-tabbar')[0] as HTMLElement;
        // let adbar = document.getElementsByTagName('ion-app')[0] as HTMLElement;
        tab.style.display = 'flex';
        // adbar.classList.add('ad-type-native');
        if (this.platform.is('cordova')) {
          this.ads.show();
        }
      } else {
        let tab = document.getElementsByClassName('show-tabbar')[0] as HTMLElement;
        // let adbar = document.getElementsByTagName('ion-app')[0] as HTMLElement;
        tab.style.display = this.defaultOrientation ? 'flex' : 'none';
        // this.defaultOrientation ? adbar.classList.add('ad-type-native') : adbar.classList.remove('ad-type-native');
        if (!this.defaultOrientation) this.ads.hide();
      }
    });
  }
  ionViewDidEnter(){
  }

  ngOnDestroy() {
    if (this.orientationSub) {
      this.orientationSub.unsubscribe();
      this.orientationSub = null;
    }
    this.defaultOrientation = true;
  }


  lockPortraitOrientation() {
    if (this.platform.is('cordova')) {
      this.screen.lockPortraitOrientation();
    }
  }
  unlockOrientations() {
    if (this.platform.is('cordova')) {
      this.screen.unlock();
    }
  }

  loadNewChart(event) {
    console.log('event.realIndex: ', event.realIndex);
    // let canvas = document.getElementById('myChart' + event.realIndex);
    // @ts-ignore
    // canvas.height = 260;
    // @ts-ignore
    // canvas.width = window.innerWidth;
    // this.configureChart(event.realIndex);
  }

  async getEndurances() {
    return new Promise<any>(async (resolve, reject) => {
      let loader = this.loadingCtrl.create({});
      loader.present();
      if (this.sessionService.isLoged) {
        this.endurances = JSON.parse(localStorage.getItem('filteredEndurances')) || [];
        console.log('this.endurances: ', this.endurances);

        for (let i = 0; i < this.endurances.length; i++) {
          await this.fillInTable(this.endurances[i]);
        }
        console.log('this.endurances: ', this.endurances);
        loader.dismiss();
        resolve(null);
      }
    })
  }

  fillInTable(endurance): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (this.sessionService.isLoged) {
        this.sessionService.getToken(false, false).then(async (token) => {
          // this.eventService.getTrainings().then(async (years: TreesCounter[]) => {
          let years = JSON.parse(localStorage.getItem('ucts.token')) || [];
          let trainings = [];
          years.forEach(y => { trainings.push({ year: y.year }) });
          this.years = [0];
          this.years = this.years.concat(years.map(y => y.year).reverse());
          for (let i = 0; i < years.length; i++) {
            await this.eventService.getMonthlyStatsPerYearCid(token, years[i].year, endurance.id, true).then((kmPerYear) => {
              trainings[i].yearStats = kmPerYear;
            });
          }
          endurance.trainings = trainings;
          resolve(trainings);
        });
        // });
      } else {
        resolve('the user is not authenticated');
      }
    });
  }

  getTrainingsData() {
    return new Promise<any>((resolve, reject) => {
      // this.eventService.getTrainings().then((trees: TreesCounter[]) => {
      let trees = JSON.parse(localStorage.getItem('ucts.token')) || [];
      if (!trees) return;
      this.treesCounter.kilometer = Math.floor(trees.reduce((acc, cur) => acc + cur.distMeterSum, 0) / 1000) + "";
      this.treesCounter.trees = Math.floor(Number(this.treesCounter.kilometer) / 50) + "";
      resolve(null);
      // });
    });
  }

  filterData() {
    for (let i = 0; i < this.events.length; i++) {
      if (typeof this.events[i].monthly === "undefined") {
        this.events.splice(i, 1);
      }
    }
  }


  shortcut(month) {
    let shortcut = month;
    switch (month) {
      case "January": shortcut = "Jan"; break;
      case "February": shortcut = "Feb"; break;
      case "March": shortcut = "Mar"; break;
      case "April": shortcut = "Apr"; break;
      case "May": shortcut = "May"; break;
      case "June": shortcut = "Jun"; break;
      case "July": shortcut = "Jul"; break;
      case "August": shortcut = "Aug"; break;
      case "September": shortcut = "Sept"; break;
      case "October": shortcut = "Oct"; break;
      case "November": shortcut = "Nov"; break;
      case "December": shortcut = "Dec"; break;
    }

    return shortcut.toUpperCase();
  }

  configureChart(index = 0) {
    if (!this.endurances.length) {this.noData=true; return };

    const canvas = document.getElementById('myChart' + index) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');
    const gradient = ctx.createLinearGradient(0, 0, 0, 135);
    gradient.addColorStop(0, '#408a79');
    gradient.addColorStop(1, 'transparent');

    let data = index > 0 ? this.activityService.createYearlyChartData(this.endurances, this.years[index]) : this.activityService.createAllYearsChartData(this.endurances);
    let datasets = data.datasets.filter(d => d.data.reduce((acc, cur) => acc + cur, 0) > 0);
    data.datasets = datasets;
    console.log('data.datasets', data.datasets)
    if(this.themeMode=="darkMode"){
      data.datasets.find(d => {
        if(d.label =="Mountainbike"){
          d.borderColor = "#55acee"
          d.pointBorderColor="#55acee"
        } });
    }
    let myLineChart = new Chart(ctx, {
      type: 'line',
      fontColor: this.themeMode==="darkMode"?'#ffffff':'#000000',
      data: data,
      options: {
        responsive: false,
        title: {
          display: true,
          text: index > 0 ? this.years[index] : ""
        },
        scales: {
          yAxes: [{
            stacked: false,
            ticks: {
              gridLines: {
                color: function (value, index, values) {
                  return value;
                },
              },
              fontColor: this.themeMode==="darkMode"?'#ffffff':'#000000',
              maxTicksLimit: 5,
              callback: function (value, index, values) {
                return value + ' km';
              }
            }
          }],
          xAxes: [{
            stacked: true,
            ticks: {
              fontColor: this.themeMode==="darkMode"?'#ffffff':'#000000',
              maxTicksLimit: 8,
              // Include a dollar sign in the ticks
              callback: function (value, index, values) {
                return value;
              },
            }
          }]
        },
        legend: {
          display: true,
          labels: {
            fontColor: this.themeMode === "darkMode" ? '#ffffff' : '#000000', // Set label font color
          }
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// /src/pages/event/event-activity-tabs/activity-statistics/activity-statistics.ts